import React from "react";
import MaterialTable from "material-table";
import { tableIcons } from "../../shared/TableIcons";
import CircularProgress from "@material-ui/core/CircularProgress";
import exportPDF from "../../services/exportPDF";
import exportCSV from "../../services/exportCSV";

const CountPerUser = (props) => {
  const { data } = props;
  return (
    <div>
      {data !== "" && data !== [] ? (
        <MaterialTable
          icons={tableIcons}
          title="Πλήθος Ειδοποιήσεων Ανά Χειριστή"
          columns={[
            {
              title: "Χειριστής",
              field: "email",
              defaultGroupOrder: 0,
            },
            {
              title: "Κατάσταση",
              field: "status",
            },
            {
              title: "Αναθέσεις",
              field: "cntOfAcknowledged",
            },
            {
              title: "Κλεισίματα",
              field: "cntOfClosed",
            },
          ]}
          data={data}
          localization={{
            body: {
              emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
            },
            toolbar: {
              addRemoveColumns: "Προσθέστε ή αφαιρέστε κολώνες",
              showColumnsTitle: "Δείξτε κολώνες",
              addTooltip: "Προσθήκη",
              searchTooltip: "Αναζήτηση",
              searchPlaceholder: "Αναζήτηση",
              exportTitle: "Εξαγωγή",
              exportCSVName: "Εξαγωγή σε CSV",
              exportPDFName: "Εξαγωγή σε PDF",
            },
            grouping: {
              placeholder: "Σύρετε για να ομαδοποιήσετε",
              groupedBy: "Σύρετε για να ομαδοποιήσετε",
            },
            pagination: {
              firstTooltip: "Πρώτη Σελίδα",
              lastTooltip: "Τελευταία Σελίδα",
              previousTooltip: "Προηγούμενη Σελίδα",
              nextTooltip: "Επόμενη Σελίδα",
              labelDisplayedRows: "{from}-{to} από {count}",
              labelRowsSelect: "Εγγραφές ανά Σελίδα",
            },
          }}
          options={{
            searchFieldAlignment: "left",
            exportPdf: (columns, data) => {
              exportPDF(columns, data);
            },
            exportCsv: (columns, data) => {
              exportCSV(columns, data);
            },
            columnsButton: true,
            exportButton: true,
            grouping: true,
            sorting: true,
            filtering: false,
            exportAllData: true,
          }}
        />
      ) : (
        <CircularProgress></CircularProgress>
      )}
    </div>
  );
};

export default CountPerUser;
